import { ReactNode, SyntheticEvent } from 'react';
import { Box, Tabs, Tab, Tooltip } from '@mui/material';
type labelOptions = {
    key: string;
    label: string;
    disable?: boolean;
    tooltip?: string;
};
type BaseTabProps = {
    tab: string;
    onChange: (prev: string) => void;
    labelOptions: labelOptions[];
    children: ReactNode;
};
const BaseTab = ({ tab, onChange, labelOptions, children }: BaseTabProps) => {
    const handleTabChange = (_event: SyntheticEvent, value: string) => {
        const target = labelOptions.find((o) => o.key === value);
        if (target?.disable) return;
        onChange(value);
    };
    return (
        <Box sx={{ width: '100%', mb: 2 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tab === 'NONE' ? false : tab} onChange={handleTabChange} sx={tabCss}>
                    {labelOptions.map((o) => (
                        <Tab
                            key={o.key}
                            value={o.key}
                            label={
                                <Tooltip title={o.disable ? o.tooltip : ''} disableHoverListener={!o.disable}>
                                    <span>{o.label}</span>
                                </Tooltip>
                            }
                            aria-disabled={o.disable}
                            onClick={(e) => {
                                if (o.disable) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }}
                            sx={{
                                opacity: o.disable ? 0.5 : 1,
                                cursor: o.disable ? 'not-allowed' : 'pointer',
                            }}
                        />
                    ))}
                </Tabs>
            </Box>
            <Box sx={{ mt: 2 }}>{children}</Box>
        </Box>
    );
};
const tabCss = {
    borderBottom: 1,
    borderColor: 'divider',
    minHeight: 48,
    '& .MuiTabs-indicator': {
        backgroundColor: '#1976d2',
        height: 3,
    },
    '& .MuiTab-root': {
        textTransform: 'none',
        fontWeight: 700,
        fontSize: '1rem',
        minHeight: 48,
        color: '',
        px: 3,
    },
    '& .MuiTab-root.Mui-selected:not(.Mui-disabled)': {
        color: '#1976d2',
        backgroundColor: '#e3f2fd',
    },
    '& .MuiTab-root:hover:not(.Mui-disabled)': {
        backgroundColor: '#f5f5f5',
    },
    '& .MuiTab-root.Mui-disabled': {
        color: '#aaa',
        backgroundColor: 'transparent',
        cursor: 'not-allowed',
    },
    '& .custom-tab-indicator': {
        display: 'none',
    },
};

export default BaseTab;
